export default "__VITE_ASSET__ef5f7970__"